import { api } from "./client";

const SESSION_KEY = "lp_session_id";

function getSessionId() {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(36).slice(2);
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

export function track(event_type, opts = {}) {
  // Fire-and-forget, never blocks UI, ignores errors silently.
  try {
    const lang = localStorage.getItem("lp_lang") || navigator.language?.slice(0, 2) || "it";
    api
      .post("/analytics/event", {
        event_type,
        target_type: opts.target_type || null,
        target_id: opts.target_id || null,
        language: lang,
        session_id: getSessionId(),
        meta: opts.meta || null,
      })
      .catch(() => {});
  } catch {
    /* ignore */
  }
}
